import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import { slugify } from "../../utils/slugify.js";
import type { Company } from "../Company.js";
import { Locale, type LocalizedString } from "../Locale.js";

export function getCompanyUrlSlug(values: Pick<Partial<Company>, "urlSlug" | "name">): LocalizedString {
	const result = sameValueForEveryLocale("");
	for (const locale of Object.values(Locale)) {
		// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
		result[locale] = slugify(values.urlSlug?.[locale] || (values.name ?? ""));
	}
	return result;
}
